import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { FormattedDate } from 'components/intl'
import { FormattedMessage } from 'react-intl'
import { connect } from 'react-redux'
import { uniqBy, get } from 'lodash'
import { compose } from 'recompose'

import { TaskApprove, TaskReturn } from 'containers/forms/tasks'
import { Modal } from 'containers/misc'
import { Table, Data } from 'components/layout/Table'
import { tasks } from 'constants/layout'
import { Button, BadgesLevels, ButtonGroup } from 'components/misc'
import { TasksAwardLeaderNote } from 'components/sections/tasks'
import { meta, tableCommon } from 'helpers/decorators'
import {
  apiTasksAwardSignoff,
  apiAwards,
  apiConfiguration
} from 'helpers/decorators/api'
import { modal } from 'redux/modules/app'
import { CONFIGURATION_KEYS } from 'constants/enums'
import config from 'config'

const enhance = compose(
  meta({
    title: 'Tasks - Award signoff',
    intlKey: 'pageTitle.tasks_award_signoff'
  }),
  apiConfiguration(),
  apiTasksAwardSignoff({
    unit: true
  }),
  apiAwards({
    updateSignoffTasks: true,
    useCommonLimit: true
  }),
  tableCommon(),
  connect(
    ({ auth }) => ({
      activeOrganizationId: auth.organization.id
    }),
    { modal }
  )
)

class TasksAwardSignoff extends Component {
  static propTypes = {
    tasks: PropTypes.object.isRequired,
    modal: PropTypes.func.isRequired,
    activeOrganizationId: PropTypes.number.isRequired,
    approveSignoffAward: PropTypes.func.isRequired,
    returnSignoffAward: PropTypes.func.isRequired,
    setUnitParams: PropTypes.func.isRequired,
    configuration: PropTypes.object.isRequired,
    setAwardSignoffSort: PropTypes.func,
    setCommonLimit: PropTypes.func
  }

  constructor(props) {
    super(props)
    this.state = {
      awardApproveSignoffId: null,
      awardReturnSignoffId: null,
      awardLevel: null,
      note: '',
      personalReflection: ''
    }
  }

  getNoteButtonIntlKey(participantPerson, modifiedBy) {
    return modifiedBy === get(participantPerson, 'id') ? 'button.view_participant' : 'button.view_nao'
  }

  getNoteButtonLabel(participantPerson, modifiedBy) {
    return modifiedBy === get(participantPerson, 'id') ? 'Participant note' : 'Award Office note'
  }

  getNoNoteMessage(participantPerson, modifiedBy) {
    return modifiedBy === get(participantPerson, 'id') ?
      <FormattedMessage id="label.no_note_from_participant" defaultMessage="No note from participant" /> :
      <FormattedMessage id="label.no_note_from_award_leader" defaultMessage="Returned by Award Office (without a revision note)" />
  }


  isButtonSecondary(participantPerson, modifiedBy) {
    return modifiedBy === get(participantPerson, 'id')
  }

  handleCalcurateDuration = (activities = []) => {
    let completedSum = 0

    let totalSum = 0
    const uniqueActivities = uniqBy(activities, 'activitySection.value')

    uniqueActivities.forEach(activity => {
      completedSum += activity.total * (activity.completedPercentage / 100)
      totalSum += activity.total
    })

    completedSum = Math.ceil(completedSum / 3600)
    totalSum = Math.ceil(totalSum / 3600)

    return `${completedSum} / ${totalSum}`
  }

  handleSetParams = params => {
    get(params, 'sort') && this.props.setAwardSignoffSort(params.sort)
  }


  handleShowNote = (note, personalReflection) => {
    this.setState(
      {
        note,
        personalReflection
      },
      () => {
        this.props.modal(`modal-note-show-${this.key}`)
      }
    )
  }

  handleReturnSignoffModal = (awardReturnSignoffId, awardLevel) => {
    this.setState(
      {
        awardReturnSignoffId,
        awardLevel
      },
      () => {
        this.props.modal('modal-return-signoff')
      }
    )
  }

  handleApproveSignoffModal = awardApproveSignoffId => {
    this.setState(
      {
        awardApproveSignoffId
      },
      () => {
        this.props.modal('modal-approve-signoff')
      }
    )
  }

  render() {
    const {
      tasks: { unit: { loading, list, offset, limit, pages, sort } },
      approveSignoffAward,
      returnSignoffAward,
      setUnitParams,
      activeOrganizationId,
      configuration,
      setCommonLimit
    } = this.props

    const isOffline = get(
      configuration,
      `valuesByOrganizationId[${activeOrganizationId}][${CONFIGURATION_KEYS.offlineAu.id}].booleanValue`,
      false
    )

    return (
      <div>
        <Table
          loading={loading}
          length={list.length}
          offset={offset}
          limit={limit}
          onSetLimit={setCommonLimit}
          pages={pages}
          sort={sort}
          ths={tasks.awardSignoff({ isOffline })}
          setParams={setUnitParams}
        >
          <Data>
            {list.map(({ id, award, date, participantPerson, modifiedBy, note, personalReflection }) => (
              <tr key={id}>
                <td>
                  <Link to={`${config.publicPath}/participants/${get(participantPerson, 'id')}`}>
                    {get(participantPerson, 'participant.globalId') ||
                    get(participantPerson, 'id')}
                  </Link>
                </td>
                <td>{get(participantPerson, 'firstName')}</td>
                <td>{get(participantPerson, 'lastName')}</td>
                <td>
                  {get(
                    award,
                    'previousCompletedAwardLevel.type.translationText'
                  ) || '---'}
                </td>
                <td>
                  <BadgesLevels levels={[award]} participantId={get(participantPerson, 'id')} overview />
                </td>
                <td>{(date && <FormattedDate value={date} />) || '-'}</td>
                <td>
                  {this.handleCalcurateDuration(get(award, 'activities'))}
                </td>
                <td>
                  {(note || personalReflection)
                    ? <Button
                      type="button"
                      link
                      intlKey={this.getNoteButtonIntlKey(participantPerson, modifiedBy)}
                      onClick={() => this.handleShowNote(note, personalReflection)}
                    >
                      {this.getNoteButtonLabel(participantPerson, modifiedBy)}
                    </Button>
                    : this.getNoNoteMessage(participantPerson, modifiedBy)}
                </td>
                {isOffline &&
                <td>
                  {get(award, 'awardMode.translationText')}
                </td>}
                <td>
                  <ButtonGroup>
                    <Button
                      onClick={() =>
                        this.handleApproveSignoffModal(get(award, 'id'))}
                      intlKey="button.approve"
                      tiny
                      secondary={!this.isButtonSecondary(participantPerson, modifiedBy)}
                    >
                      Approve
                    </Button>
                    <Button
                      onClick={() =>
                        this.handleReturnSignoffModal(
                          get(award, 'id'),
                          get(award, 'awardLevel')
                        )}
                      intlKey="button.revise"
                      tiny
                      secondary={this.isButtonSecondary(participantPerson, modifiedBy)}
                    >
                      Revise
                    </Button>
                  </ButtonGroup>
                </td>
              </tr>
            ))}
          </Data>
        </Table>
        <Modal
          id={`modal-note-show-${this.key}`}
          closeAction="Close"
          intlKeyClose="modal.close"
        >
          <TasksAwardLeaderNote note={this.state.note} personalReflection={this.state.personalReflection} />
        </Modal>
        <Modal id="modal-approve-signoff" customActions>
          <TaskApprove
            approve={approveSignoffAward}
            id={this.state.awardApproveSignoffId}
            modal={this.props.modal}
            title="Approve award"
            intlKey="tasks.approve_award"
            withNote
          />
        </Modal>
        <Modal id="modal-return-signoff" customActions>
          <TaskReturn
            returnTask={returnSignoffAward}
            id={this.state.awardReturnSignoffId}
            awardLevel={this.state.awardLevel}
            modal={this.props.modal}
            title="Return award"
            intlKey="tasks.return_award"
            withOptions
          />
        </Modal>
      </div>
    )
  }
}

export default enhance(TasksAwardSignoff)
